<template>
    <img
        :src="require('@/assets/icons/i-notizbuch.svg')"
        class="notebook"
        :class="[inText && 'in-text']"
    >
</template>

<script>
export default {
    name: 'Notebook',
    props: {
        inText: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" src="./Notebook.scss" />
